<script lang="ts" setup>
import {
  BlockCarouselImageSelectFields,
  BlockCarouselManualFields,
  BlockCoverAnimationFields,
  BlockCoverNavigationFields,
  BlockCoverPaletteFields,
  BlockCoverUPSFields,
  BlockCoverVariantsFields,
  BlockFAQCollectionFields,
  BlockFooterCTAFields,
  BlockFormFields,
  BlockImageCollectionFields,
  BlockImageTextFields,
  BlockImageWithTextCollectionFields,
  BlockProjectStatsFields,
  BlockSimpleSpecificationFields,
  BlockSingleQuoteFields,
  BlockVerticalSliderFields,
} from '~/utils/CmsBlockFields'

const { $directus, $readSingleton } = useNuxtApp()

const { data } = await useAsyncData('blog_overview', async () => {
  return $directus.request($readSingleton('blog_overview', {
    fields: ['*', {
      seo: ['*', {
        translations: ['*'],
      }],
      translations: ['*'],
      hero_image: ['*'],
      hero_video: ['*'],

      blocks: [
        'collection',
        'id',
        {
          item: {
            block_carousel_image_select: BlockCarouselImageSelectFields,
            block_carousel_manual: BlockCarouselManualFields,
            block_footer_cta: BlockFooterCTAFields,
            block_image_collection: BlockImageCollectionFields,
            block_image_text: BlockImageTextFields,
            block_cover_animation: BlockCoverAnimationFields,
            block_cover_navigation: BlockCoverNavigationFields,
            block_cover_palette: BlockCoverPaletteFields,
            block_cover_ups: BlockCoverUPSFields,
            block_cover_variants: BlockCoverVariantsFields,
            block_project_stats: BlockProjectStatsFields,
            block_single_quote: BlockSingleQuoteFields,
            block_faq_collection: BlockFAQCollectionFields,
            block_form: BlockFormFields,
            block_image_with_text_collection: BlockImageWithTextCollectionFields,
            block_simple_specification: BlockSimpleSpecificationFields,
            block_vertical_slider: BlockVerticalSliderFields,
            // blog specific
            block_blog_index: ['*'],
          },
        },
      ],
    }],
  }))
})
</script>

<template>
  <div>
    <HeroIndex :data="(data as any)" />
    <div>
      <div v-for="block in data?.blocks" :key="block.id">
        <BlockCarouselImageSelect v-if="block.collection === 'block_carousel_image_select'" :data="block.item" />
        <BlockCarouselManual v-else-if="block.collection === 'block_carousel_manual'" :data="block.item" />
        <BlockFooterCTA v-else-if="block.collection === 'block_footer_cta'" :data="block.item" />
        <BlockImageCollection v-else-if="block.collection === 'block_image_collection'" :data="block.item" />
        <BlockImageText v-else-if="block.collection === 'block_image_text'" :data="block.item" />
        <BlockPoolAnimation v-else-if="block.collection === 'block_cover_animation'" :data="block.item" />
        <BlockPoolNavigation v-else-if="block.collection === 'block_cover_navigation'" />
        <BlockPoolPalette v-else-if="block.collection === 'block_cover_palette'" :data="block.item" />
        <BlockPoolUPS v-else-if="block.collection === 'block_cover_ups'" :data="block.item" />
        <BlockPoolVariants v-else-if="block.collection === 'block_cover_variants'" :specs="data?.tech_specs!" :data="block.item" />
        <BlockProjectStats v-else-if="block.collection === 'block_project_stats'" :data="block.item" />
        <BlockSingleQuote v-else-if="block.collection === 'block_single_quote'" :data="block.item" />
        <BlockFAQCollection v-else-if="block.collection === 'block_faq_collection'" :data="block.item" />
        <BlockForm v-else-if="block.collection === 'block_form'" :data="block.item" />
        <BlockImageWithTextCollection v-else-if="block.collection === 'block_image_with_text_collection'" :data="block.item" />
        <BlockSimpleSpecification v-else-if="block.collection === 'block_simple_specification'" :data="block.item" />
        <BlockVerticalSlider v-else-if="block.collection === 'block_vertical_slider'" :data="block.item" />
        <BlockBlogIndex v-else-if="block.collection === 'block_blog_index'" />
      </div>
    </div>
  </div>
</template>

<style>

</style>
